export default __webpack_public_path__ + "static/media/Group9155.753b051f.svg";